import { render, staticRenderFns } from "./DocumentCard.vue?vue&type=template&id=f932980e"
import script from "./DocumentCard.vue?vue&type=script&lang=js"
export * from "./DocumentCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentCard.vue?vue&type=style&index=0&id=f932980e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports